/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_School_ManagementInputs */

const nl_nav_school_management = /** @type {(inputs: Nav_School_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schoolbeheer`)
};

/**

* @param {Nav_School_ManagementInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_school_management = /** @type {((inputs?: Nav_School_ManagementInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_School_ManagementInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_school_management(inputs)
});
export { nav_school_management as "nav.school_management" }